export default {
    "Authentication.forgot_password": "forgot password",
    "Authentication.logging_in": "logging in...",
    "Authentication.remember_password": "I remember my password",
}